import { BillingEntitlementStateService } from '@services/billing-entitlement-state.service'
import { EntitlementName } from '@app/domain/Entitlement'
import { Observable, map, of } from 'rxjs'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'hasBillingEntitlement',
})
export class HasBillingEntitlementPipe implements PipeTransform {

    constructor(private entitlementStateService: BillingEntitlementStateService) { }

    transform(entitlementName: EntitlementName | null | undefined): Observable<boolean> {
        if (entitlementName === null || entitlementName === undefined) {
            return of(false)
        }
        return this.entitlementStateService.getState$(entitlementName)
            .pipe(
                map(state => state === 'unlocked')
            )
    }
}
